const templateTypes = [
  'LOAD_SUMMARY_TEMPLATES',
  'LOAD_ANALYTICS_TEMPLATES',
  'LOAD_CAMPAIGN_TEMPLATES',
  'SELECT_SUMMARY_DASHBOARD',
  'SELECT_ANALYTICS_DASHBOARD',
  'SELECT_CAMPAIGN_DASHBOARD'
];

export default templateTypes;
